module.exports = __webpack_public_path__ + "img/saudia-6.95936334.png";